import api from './axios';

export const adminsAPI = {
  getList:  ()           => api.get('/admin/admins'),
  create:   (payload)    => api.post('/admin/admins', payload),
  update:   (id, payload) => api.put(`/admin/admins/${id}`, payload),
  delete:   (id)         => api.delete(`/admin/admins/${id}`),
};
